import { render, staticRenderFns } from "./chartdashboard.component.vue?vue&type=template&id=186b7b02&scoped=true"
import script from "./chartdashboard.component.vue?vue&type=script&lang=js"
export * from "./chartdashboard.component.vue?vue&type=script&lang=js"
import style0 from "./chartdashboard.component.vue?vue&type=style&index=0&id=186b7b02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186b7b02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
